import Vue from 'vue';
import type { Plugin } from 'vuex';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import { VuexPersistHelper } from '../session/helpers/vuex-persist.helper';
import { session } from '../session/store/session.store';
import { signing } from '../signing/store/signing.store';
import { actions } from './root.actions';
import { getDefaultState } from './root.constants';
import { mutations } from './root.mutations';
import type { RootState } from './root.types';

Vue.use(Vuex);

const storageKey: string = VuexPersistHelper.getSessionKey(window.location.href);
const vuexLocalStorage = new VuexPersist({
  key: storageKey,
  storage: window.localStorage,
  reducer: (state: any) => ({
    session: {
      token: state.session.token,
    },
    recipientId: state.recipientId,
    signing: {
      initials: state.signing.initials,
    },
  }),
});

const previewKey: string = VuexPersistHelper.getPreviewKey(window.location.href);
const vuexPreviewLocalStorage = new VuexPersist({
  key: previewKey,
  storage: window.sessionStorage,
  reducer: (state: any) => ({
    session: {
      token: state.session.token,
    },
  }),
});

const plugins: Plugin<RootState>[] = [];
if (storageKey) {
  plugins.push(vuexLocalStorage.plugin);
}

if (previewKey) {
  plugins.push(vuexPreviewLocalStorage.plugin);
}

export default new Vuex.Store<RootState>({
  state: getDefaultState(),
  actions,
  mutations,
  modules: {
    signing,
    session,
  },
  plugins,
});
